import { useState } from "react";
import { api, fmtError } from "../api";
import { toast } from "sonner";
import { ArrowLeft, Megaphone, Send, Loader2, CalendarDays } from "lucide-react";

// Rundmail / Abwesenheit: freie Nachricht + Urlaubszeitraum an alle Personen
// mit Rechten auf den Standorten des Absenders.
export function Rundmail({ onClose }) {
  const token = sessionStorage.getItem("mag_token");
  const [message, setMessage] = useState("");
  const [start, setStart] = useState("");
  const [end, setEnd] = useState("");
  const [includeGf, setIncludeGf] = useState(false);
  const [busy, setBusy] = useState(false);

  const canSend = message.trim().length > 0 && !!start && !!end && !busy;

  const submit = async () => {
    if (!message.trim()) { toast.error("Bitte eine Nachricht eingeben."); return; }
    if (!start || !end) { toast.error("Bitte Start- und Enddatum angeben."); return; }
    if (end < start) { toast.error("Das Enddatum darf nicht vor dem Startdatum liegen."); return; }
    setBusy(true);
    try {
      const { data } = await api.post("/magauth/broadcast",
        { message: message.trim(), start_date: start, end_date: end, include_gf: includeGf },
        { headers: { Authorization: `Bearer ${token}` } });
      if (!data.recipients) {
        toast.warning("Keine Empfänger gefunden – es gibt niemanden mit Rechten auf deinen Standorten.");
      } else {
        toast.success(`Rundmail an ${data.sent}/${data.recipients} Empfänger gesendet${data.gf ? ` (inkl. ${data.gf} Geschäftsführung)` : ""}.`);
        onClose();
      }
    } catch (e) {
      toast.error(fmtError(e, "Rundmail konnte nicht gesendet werden"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex flex-col" style={{ background: "#F8FAFC" }} data-testid="rundmail">
      <div className="flex items-center gap-3 px-4 py-3" style={{ background: "#fff", borderBottom: "1px solid #E2E8F0" }}>
        <button data-testid="rundmail-back" onClick={onClose}
          className="w-9 h-9 rounded-lg flex items-center justify-center flex-shrink-0"
          style={{ background: "#F1F5F9", border: "none", cursor: "pointer" }}><ArrowLeft size={18} /></button>
        <span className="w-9 h-9 rounded-xl flex items-center justify-center flex-shrink-0" style={{ background: "#FFF7ED" }}>
          <Megaphone size={18} color="#F97316" />
        </span>
        <div className="min-w-0 flex-1">
          <div className="font-extrabold text-base truncate">Rundmail / Abwesenheit</div>
          <div className="text-xs truncate" style={{ color: "#64748B" }}>
            An die Personen deiner Standorte – Geschäftsführung optional
          </div>
        </div>
      </div>

      <div className="flex-1 overflow-y-auto">
        <div className="container-wd py-6" style={{ maxWidth: 640 }}>
          <div className="card-wd p-4 sm:p-5">
            <label className="text-xs font-bold" style={{ color: "#475569" }}>Nachricht</label>
            <textarea data-testid="rundmail-message" className="input-wd mt-1" rows={5}
              placeholder="z. B. Ich bin im angegebenen Zeitraum im Urlaub. Vertretung bitte an …"
              value={message} onChange={(e) => setMessage(e.target.value)}
              style={{ resize: "vertical", minHeight: 120 }} />

            <div className="flex items-center gap-2 mt-4 mb-1">
              <CalendarDays size={15} color="#F97316" />
              <span className="text-xs font-bold" style={{ color: "#475569" }}>Urlaubszeitraum</span>
            </div>
            <div className="flex flex-col sm:flex-row gap-3">
              <div className="flex-1">
                <label className="text-xs" style={{ color: "#64748B" }}>Von</label>
                <input data-testid="rundmail-start" type="date" className="input-wd mt-1"
                  value={start} onChange={(e) => setStart(e.target.value)} />
              </div>
              <div className="flex-1">
                <label className="text-xs" style={{ color: "#64748B" }}>Bis</label>
                <input data-testid="rundmail-end" type="date" className="input-wd mt-1"
                  min={start || undefined} value={end} onChange={(e) => setEnd(e.target.value)} />
              </div>
            </div>

            <label className="flex items-start gap-2 mt-4 cursor-pointer" data-testid="rundmail-gf-label">
              <input type="checkbox" data-testid="rundmail-include-gf" checked={includeGf}
                onChange={(e) => setIncludeGf(e.target.checked)} style={{ marginTop: 3 }} />
              <span className="text-sm" style={{ color: "#475569" }}>
                Geschäftsführung informieren
                <span className="block text-xs" style={{ color: "#94A3B8" }}>Nimmt zusätzlich die Administratoren (Geschäftsführung) in den Verteiler auf.</span>
              </span>
            </label>

            <div className="flex items-center justify-end mt-5">
              <button data-testid="rundmail-send" className="btn-primary" disabled={!canSend} onClick={submit} style={{ height: 44 }}>
                {busy ? <Loader2 size={16} className="animate-spin" /> : <Send size={16} />} Rundmail senden
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
